import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { waterFillingMachines } from '../../mock/mockData';

const WaterFilling90BPM = () => {
  const productData = waterFillingMachines.find(p => p.id === 'wfm-90');
  return <ProductPageTemplate productData={productData} />;
};

export default WaterFilling90BPM;